var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRolarBaixo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    transform: "matrix(-6.773322e-03 -1 1 -6.773322e-03 0.1223 36.1215)",
    className: "st0",
    width: 35.2,
    height: 35.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6_",
    d: "M16.4,0.4l0.2,27.3l-9.8-9.8l-2.6,2.7l14.2,14.3l14-14.5l-2.6-2.6l-9.6,10L20.1,0.4L16.4,0.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRolarBaixo01);
export default __webpack_public_path__ + "static/media/ico-rolar-baixo-01.676481c5299aca4636e7fd449eb9c15e.svg";
export { ForwardRef as ReactComponent };